package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PlaidItemDto(
    @SerialName("item_id") val itemId: String,
    @SerialName("institution_name") val institutionName: String,
    @SerialName("created_at") val createdAt: String,
    @SerialName("balances_last_synced_at") val balancesLastSyncedAt: String? = null,
    @SerialName("transactions_last_synced_at") val transactionsLastSyncedAt: String? = null,
    @SerialName("recurring_last_synced_at") val recurringLastSyncedAt: String? = null,
    @SerialName("investments_last_synced_at") val investmentsLastSyncedAt: String? = null,
    @SerialName("login_required") val loginRequired: Boolean = false,
    @SerialName("update_required") val updateRequired: Boolean = false,
    @SerialName("subscription_required") val subscriptionRequired: Boolean = false,
)

@Serializable
data class PlaidItemsResponse(
    @SerialName("items") val items: List<PlaidItemDto>,
)
